import { Heading } from "@chakra-ui/react";
import Comments from "components/Comments";
import { COMMENTS_TITLE } from "components/Comments/utils";
import { getLayout } from "components/Layout";
import PageSection from "components/Layout/PageSection";
import HeadTitle from "components/Shared/HeadTitle";

export default function CommentsIndex() {
  return (
    <PageSection paddingTop="3rem">
      <HeadTitle title={COMMENTS_TITLE} />
      <Comments
        headerLeft={
          <Heading as="h1" variant="section-header">
            {COMMENTS_TITLE}
          </Heading>
        }
      />
    </PageSection>
  );
}

CommentsIndex.getLayout = getLayout;
